import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TdoNoteFilterModel } from '../models/tdo-note-filter.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { NoteDataModel } from '../../../../models/notes/note-data.model';
import { Constants } from '../../../../constants';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TdoNoteBuilderComponent } from '../../tdo-note-builder/tdo-note-builder.component';
import { TdoMacroNotesComponent } from '../../tdo-macro-notes/tdo-macro-notes.component';
import { NotesService } from '../../../../services/notes.service';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../models/tdo-note-save-model';
import { TdoNoteQueryModel } from '../models/tdo-note-query.model';
import { Globals } from '../../../../globals';
import { NoteCategoryDataModel } from '../../../../models/notes/note-category-data.model';
import { NoteTypeDataModel } from '../../../../models/notes/note-type-data.model';
import { StaticDataService } from '../../../../services/static-data.service';
import { NoteBuilderComponent } from '../../../../modules/notes/note-builder/note-builder.component';
import { AuthenticationService } from '../../../../modules/auth/services/authentication.service';
import { UserRoleEnum } from '../../../../models/enum/user-role.enum';
import { NoteDialogComponent } from "./dialog/note-dialog/note-dialog.component";
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { DialogService } from 'src/app/services/dialog.service';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {  NgZone, ViewChild} from '@angular/core';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-tdo-note',
  templateUrl: './tdo-note.component.html',
  styleUrls: ['./tdo-note.component.scss']
})
export class TdoNoteComponent implements OnInit {
  @Input() storedNoteFilterSettings: TdoNoteFilterModel;
  @Input() note: NoteDataModel;
  @Input() notesCategories: EnumValidValueItemModel[] = [];
  @Input() notesTypes: EnumValidValueItemModel[] = [];
  @Input() autoSaveMsDelay: number = 2000;
  @Input() isLastItem: boolean = false;

  @Input() noteQueryModel: TdoNoteQueryModel;
  @Output() noteChange: EventEmitter<NoteDataModel> = new EventEmitter<NoteDataModel>();




  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  constructor(private _ngZone: NgZone,
    private dialog: MatDialog,
    private staticDataService: StaticDataService,
    private globals: Globals,
    private authenticationService: AuthenticationService,
    private dialogService: DialogService,
    private notesService: NotesService) { }

  ngOnInit(): void {

  }
  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  getTextColor(note: NoteDataModel) {
    if (note && note.dataNoteTypes && note.dataNoteTypes.length > 0) {
      const alert = note.dataNoteTypes.find(p => p.enumNoteType.ItemDisplayValue.toLowerCase() === 'alert');
      if (alert) {
        return 'white';
      } else {
        return 'black';
      }
    } else {
      return 'none';
    }
  }

  getBackgroundColor(note: NoteDataModel) {
    if (note && note.dataNoteTypes && note.dataNoteTypes.length > 0) {
      const alert = note.dataNoteTypes.find(p => p.enumNoteType?.ItemDisplayValue?.toLowerCase() === 'alert');
      if (alert) {
        return 'rgba(255,0,0,1)';
      } else {
        return 'none';
      }
    } else {
      return 'none';
    }
  }

  auto_grow(element) {
    console.log('input element ', element);

    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  isNoteLocked(dataNote: NoteDataModel) {
    if (!dataNote) {
      return null;
    }

    if (dataNote.isLocked === true) {
      return true;
    }
    else {
      const nowDate = new Date();
      const createdDate = new Date(dataNote.xauditModifiedBy);
      const msDiff = nowDate.getTime() - createdDate.getTime();

      // Num milliseconds in 24 hours 86400000
      return msDiff >= 86400000;
    }
  }

  getDate(date: any) {
    if (date != null) {
      if (date instanceof Date) {

      } else {
        if (!date.includes('Z')) {
          date += 'Z';
        }
      }
      const date1 = new Date(date);
      let hours = date1.getHours();
      let demarcation = 'AM';
      if (hours > 12) {
        hours -= 12;
        demarcation = 'PM';
      } else {
        if (hours === 0) {
          hours = 12;
        }
      }

      let minutes = '';
      const minutesNum = date1.getMinutes();
      if (minutesNum < 10) {
        minutes = '0' + minutesNum.toString();
      } else {
        minutes = minutesNum.toString();
      }
      return Constants.monthNamesAbbreviated[date1.getMonth()] + ' ' + date1.getDate() + ', ' + date1.getFullYear() + ' | ' + hours + ':' + minutes + ' ' + demarcation;
    }
  }

  onNoteInput(event: string, noteData: NoteDataModel) {
    this.saveDataNote();
  }

  onCategoryDropdownSelectionComplete(items: NoteCategoryDataModel[], noteData: NoteDataModel) {
    this.note.dataNoteCategories = items;
    this.saveDataNote();
  }

  onTypeDropdownSelectionComplete(items: NoteTypeDataModel[], noteData: NoteDataModel) {
    this.note.dataNoteTypes = items;
    const alertType = items.find(p => p.enumNoteTypeID === NoteTypeEnum.Alert);
    if (alertType) {
      this.noteChange.emit(this.note);
    }
    this.saveDataNote();
  }

  deleteNote(): void {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete this note?`).subscribe((result) => {
      if (result === true) {
        this.note.xauditDeleted = true;


        this.saveDataNote();
        this.noteChange.emit(this.note);
      }
    });
  }
  saveDataNote() {
    const model = new TdoNoteSaveModel();
    model.text = this.note.Note;
    model.dataNote = this.note;


    if (model.dataNote.dataNoteCategories) {
      model.categoryEnumIds = model.dataNote.dataNoteCategories.map(p => p.enumNoteCategoryID);
    }

    if (model.dataNote.dataNoteTypes) {
      model.typeEnumIds = model.dataNote.dataNoteTypes.map(p => p.enumNoteTypeID);
    }

    const assoc = new TdoNoteAssociatedObject();
    assoc.parentObjectName = this.noteQueryModel.parentObjectName;
    assoc.objectId = this.noteQueryModel.objectId;
    model.patientId = this.noteQueryModel.patientId;

    const alreadyExistModel = model.associatedObjects.find(p => p.parentObjectName === this.noteQueryModel.parentObjectName && p.objectId === this.noteQueryModel.objectId);
    if (!alreadyExistModel) {
      model.associatedObjects.push(assoc);
    }
    this.notesService.saveNote(model).subscribe((res) => {
      this.note = res;
    });
  }

  openNoteBuilder(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoNoteBuilderComponent, config).afterClosed().subscribe((data) => {
      if(data)  {
      if (data.length > 0) {
        dataNote.Note =  data;
        this.saveDataNote();
      }
    }
    });
  }

  openMacroNotes(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoMacroNotesComponent, config).afterClosed().subscribe((data) => {
      if(data)  {
      if (data.length > 0) {
        dataNote.Note += '\n' + data;
        this.saveDataNote();
      }
    }
    });
  }

  isUserHasRoleToEdit() {
    return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Notes);
  }

  openNoteDialog() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.note;
    this.dialog.open(NoteDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.note = res;
        this.saveDataNote();
      }
    });
  }

  lockNote() {
    this.dialogService.openConfirmDialog(`Are you sure you want to lock this note?`).subscribe((result) => {
      if (result === true) {
        this.note.xauditModifiedOn = new Date();
        this.note.xauditModifiedBy = this.authenticationService.currentUserValue.authdata.userid;
        this.note.isLocked = true;

        this.saveDataNote();
        this.noteChange.emit(this.note);
      }
    });
  }

  unlockNote() {
    this.dialogService.openConfirmDialog(`Are you sure you want to unlock this note?`).subscribe((result) => {
      if (result === true) {
        this.note.xauditModifiedOn = new Date();
        this.note.xauditModifiedBy = this.authenticationService.currentUserValue.authdata.userid;
        this.note.isLocked = false;

        this.saveDataNote();
        this.noteChange.emit(this.note);
      }
    });
  }
}
